// extracted by mini-css-extract-plugin
module.exports = {"Color":"Color_Color__2xyPX","NoColor":"Color_NoColor__3-uYp","NoColorIcon":"Color_NoColorIcon__1xMPR"};